module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/visionary-voices.json
// module id = 1515
// module chunks = 224337986557384